// Prozeduraler Avatar-Baukasten: kleine Spezifikation, die Client (SVG) und Server (Validierung) teilen.

export interface AvatarSpec {
  skin: number;
  hair: number;
  hairColor: number;
  beard: number;
  hat: number;
  glasses: number;
  shirt: number;
  bg: number;
}

export const AVATAR_OPTIONS: Record<keyof AvatarSpec, number> = {
  skin: 5,
  hair: 6,
  hairColor: 6,
  beard: 4,
  hat: 5,
  glasses: 3,
  shirt: 8,
  bg: 6,
};

/** Palettenfarben (Stilrichtlinie) */
export const AV_SKIN = ['#f1c9a5', '#e0a982', '#c68863', '#9a6544', '#6e4630'];
export const AV_HAIR = ['#2a1d14', '#5c3720', '#a8692e', '#d9b56a', '#9aa0a6', '#efe2c4'];
export const AV_SHIRT = ['#e0a346', '#4a8582', '#bf5240', '#6b8050', '#24395a', '#8e2f25', '#b08a3e', '#3f5233'];
export const AV_BG = ['#16243a', '#2f5d62', '#5c3720', '#3a5578', '#3f5233', '#8e2f25'];

export function randomAvatar(rand: () => number = Math.random): AvatarSpec {
  const o = {} as AvatarSpec;
  for (const [k, n] of Object.entries(AVATAR_OPTIONS)) o[k as keyof AvatarSpec] = Math.floor(rand() * n);
  return o;
}

/** Eingaben vom Client bereinigen (unbekannte Felder weg, Bereiche erzwingen) */
export function cleanAvatar(a: unknown): AvatarSpec | undefined {
  if (!a || typeof a !== 'object') return undefined;
  const o = {} as AvatarSpec;
  for (const [k, n] of Object.entries(AVATAR_OPTIONS)) {
    const v = Math.floor(Number((a as Record<string, unknown>)[k]));
    o[k as keyof AvatarSpec] = Number.isFinite(v) ? Math.max(0, Math.min(n - 1, v)) : 0;
  }
  return o;
}
